module.exports = __webpack_public_path__ + "static/05-e24f217721519684313dff4e27ec14c4.jpg";